import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { clientMedia, clients } from '../../mockData';
import './ClientMedia.css';

function ClientMedia() {
  const { Title } = Typography;

  const columns = [
    { title: 'Client', key: 'client', render: (_, r) => clients.find((c) => c.id === r.clientId)?.name || '—' },
    { title: 'Type', dataIndex: 'type', key: 'type', render: (t) => <Tag>{t.toUpperCase()}</Tag> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Tags', dataIndex: 'tags', key: 'tags', render: (tags) => (tags || []).map((x) => <Tag key={x}>{x}</Tag>) },
  ];

  return (
    <div className="agency-creatives-client-media">
      <Title level={3}>Client-Specific Media</Title>
      <Table rowKey="id" columns={columns} dataSource={clientMedia} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default ClientMedia;
